import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import {
  BeatLoader
} from "react-spinners";
import { Link } from "react-router-dom";
const signupValidationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Required"),
  first_name: Yup.string().required("Required"),
  last_name: Yup.string().required("Required"),
  phone_number: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(10, "Must be at least 10 digits")
    .max(15, "Must be at most 15 digits")
    .required("Required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
});

const SignUpPopUp = ({ Loginpop, SetLoginPop, Registerpop, SetRegisterpop }) => {
  const [showPassword, setShowPassword] = useState(true);
  const [LastScreen, setLastScreen] = useState(false);
  const checkEmailExists = async (email) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_AWS}/check_email_exists/`,
        {
          params: { email: email },
        }
      );
      return response.data; // Assumes the response contains a field 'exists' which is a boolean
    } catch (error) {
      console.error("Error checking email:", error);
      return false;
    }
  };

  const registerUser = async (userData) => {
    try {
      //console.log(userData, "asd");
      let userData2 = {
        email: userData.email,
        first_name: userData.first_name,
        last_name: userData.last_name,
        password: userData.password,
        phone_number: userData.phone_number,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_AWS}/signupuser`,
        userData2
      );
      return response.data; // handle response data here
    } catch (error) {
      console.error(error); // handle error here
      return null;
    }
  };
  return (
    <div className="fixed top-0 left-0 z-[3000] w-screen h-screen backdrop-blur-sm  bg-black bg-opacity-50  font-jt">
      <div className="flex relative flex-col lg:flex-row bg-white h-full lg:h-[98vh] lg:mt-2 lg:my-2 w-[100%] lg:w-[84%] lg:rounded-2xl mx-auto py-8 shadow-lg ">
        <button
          onClick={() => { SetRegisterpop(!Registerpop) }}
          className="absolute top-4 right-4 transition-all hover:scale-[1.05] text-gray-600 hover:text-gray-800">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0001 0.416656C12.918 0.416656 9.90512 1.3306 7.34245 3.04292C4.77979 4.75524 2.78243 7.18902 1.60297 10.0365C0.4235 12.884 0.114898 16.0173 0.716184 19.0401C1.31747 22.063 2.80164 24.8397 4.98101 27.0191C7.16038 29.1984 9.93706 30.6826 12.9599 31.2839C15.9828 31.8852 19.1161 31.5766 21.9636 30.3971C24.8111 29.2176 27.2448 27.2203 28.9572 24.6576C30.6695 22.095 31.5834 19.0821 31.5834 16C31.5834 11.867 29.9416 7.90335 27.0192 4.98091C24.0967 2.05847 20.133 0.416656 16.0001 0.416656ZM22.6683 20.6651C22.8036 20.7958 22.9116 20.9521 22.9858 21.1249C23.0601 21.2978 23.0991 21.4837 23.1008 21.6718C23.1024 21.8599 23.0666 22.0464 22.9953 22.2205C22.9241 22.3946 22.8189 22.5528 22.6859 22.6858C22.5529 22.8188 22.3947 22.924 22.2206 22.9952C22.0465 23.0665 21.86 23.1023 21.6719 23.1007C21.4837 23.099 21.2979 23.06 21.125 22.9857C20.9522 22.9115 20.7959 22.8035 20.6652 22.6682L16.0001 18.0032L11.335 22.6682C11.2043 22.8035 11.048 22.9115 10.8752 22.9857C10.7023 23.06 10.5164 23.099 10.3283 23.1007C10.1402 23.1023 9.95367 23.0665 9.77957 22.9952C9.60547 22.924 9.44729 22.8188 9.31428 22.6858C9.18126 22.5528 9.07607 22.3946 9.00484 22.2205C8.93361 22.0464 8.89777 21.8599 8.8994 21.6718C8.90103 21.4837 8.94011 21.2978 9.01436 21.1249C9.08861 20.9521 9.19653 20.7958 9.33184 20.6651L13.9969 16L9.33184 11.3349C9.19653 11.2042 9.08861 11.0479 9.01436 10.8751C8.94011 10.7022 8.90103 10.5163 8.8994 10.3282C8.89777 10.1401 8.93361 9.95357 9.00484 9.77947C9.07607 9.60537 9.18126 9.44719 9.31428 9.31418C9.44729 9.18116 9.60547 9.07597 9.77957 9.00474C9.95367 8.93351 10.1402 8.89767 10.3283 8.8993C10.5164 8.90094 10.7023 8.94002 10.8752 9.01426C11.048 9.08851 11.2043 9.19643 11.335 9.33174L16.0001 13.9968L20.6652 9.33174C20.7959 9.19643 20.9522 9.08851 21.125 9.01426C21.2979 8.94002 21.4837 8.90094 21.6719 8.8993C21.86 8.89767 22.0465 8.93351 22.2206 9.00474C22.3947 9.07597 22.5529 9.18116 22.6859 9.31418C22.8189 9.44719 22.9241 9.60537 22.9953 9.77947C23.0666 9.95357 23.1024 10.1401 23.1008 10.3282C23.0991 10.5163 23.0601 10.7022 22.9858 10.8751C22.9116 11.0479 22.8036 11.2042 22.6683 11.3349L18.0033 16L22.6683 20.6651Z"
              fill="#D00808"
            />
          </svg>
        </button>
        <img
          src="/Untitled.png"
          alt=""
          className="lg:block hidden  mx-auto my-[40px] h-[600px] w-[600px] "
        />
        {LastScreen === false ? (
          <div className="bg-white p-4 lg:p-8 rounded-lg w-full lg:w-1/2">
            <h2 className="text-2xl font-extrabold mb-3 text-[45px]">
              Sign Up
            </h2>
            <p className="text-[#241E1E] font-thin mt-6 mb-8 text-[25px]">
              Please fill this form to continue
            </p>

            <Formik
              initialValues={{
                email: "",
                first_name: "",
                last_name: "",
                phone_number: "",
                password: "",
                confirmPassword: "",
              }}
              validationSchema={signupValidationSchema}
              onSubmit={async (values, { setSubmitting, setFieldError }) => {
                //console.log("ASDDSA");
                // Check if email already exists
                const emailExists = await checkEmailExists(values.email);
                if (emailExists?.email_exists) {
                  setFieldError(
                    "email",
                    "This email already exists. Please use a different email."
                  );
                  setSubmitting(false);
                  return;
                }

                // If email is unique, proceed with registration
                const response = await registerUser(values);
                if (response) {
                  setLastScreen(true)
                  // Handle any post-registration actions here, such as redirecting to a different page
                } else {
                  alert("Registration failed.");
                }

                setSubmitting(false);
              }}
            >
              {({ isSubmitting }) => (
                <Form className="space-y-4">
                  <div className="flex flex-row justify-between">
                    <div className="relative w-[48%] ">
                      <label
                        htmlFor="first_name"
                        className="ml-6  bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                      >
                        First Name
                      </label>
                      <Field
                        id="first_name"
                        name="first_name"
                        type="text"
                        className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                      />
                      <ErrorMessage
                        name="first_name"
                        className="text-red-600 text-sm ml-5"
                        component="div"
                      />
                    </div>
                    <div className="relative w-[48%] ">
                      <label
                        htmlFor="last_name"
                        className="ml-6 bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                      >
                        Last Name
                      </label>
                      <Field
                        id="last_name"
                        name="last_name"
                        type="text"
                        className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                      />
                      <ErrorMessage
                        name="last_name"
                        className="text-red-600 text-sm ml-5"
                        component="div"
                      />
                    </div>
                  </div>
                  <div className="relative">
                    <label
                      htmlFor="phone_number"
                      className="ml-6 bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                    >
                      Contact Number
                    </label>
                    <Field
                      id="phone_number"
                      name="phone_number"
                      type="text"
                      className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                    />
                    <ErrorMessage
                      name="phone_number"
                      className="text-red-600 text-sm ml-5"
                      component="div"
                    />
                  </div>
                  <div className="relative">
                    <label
                      htmlFor="email"
                      className="ml-6 bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                    >
                      Email
                    </label>
                    <Field
                      id="email"
                      name="email"
                      type="email"
                      className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                    />
                    <ErrorMessage
                      name="email"
                      className="text-red-600 text-sm ml-5"
                      component="div"
                    />
                  </div>
                  <div className="relative">
                    <label
                      htmlFor="password"
                      className="ml-6 bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                    >
                      Create Password
                    </label>
                    <Field
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-7 transform -translate-y-1/2"
                    >
                      {!showPassword ? (
                        <i class="fa fa-eye-slash" aria-hidden="true"></i>
                      ) : (
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      )}
                    </button>
                    <ErrorMessage
                      name="password"
                      className="text-red-600 text-sm ml-5"
                      component="div"
                    />
                  </div>
                  <div className="relative">
                    <label
                      htmlFor="confirmPassword"
                      className="ml-6 bg-white font-semibold text-[16px] absolute -top-[11px] left-2 z-10"
                    >
                      Confirm Password
                    </label>
                    <Field
                      id="confirmPassword"
                      name="confirmPassword"
                      type={showPassword ? "text" : "password"}
                      className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-7 transform -translate-y-1/2"
                    >
                      {!showPassword ? (
                        <i class="fa fa-eye-slash" aria-hidden="true"></i>
                      ) : (
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      )}
                    </button>
                    <ErrorMessage
                      name="confirmPassword"
                      className="text-red-600 text-sm ml-5"
                      component="div"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-black text-white w-full  py-2 rounded-full mb-6 shadow-md mt-5"
                  >
                    {isSubmitting ? (<BeatLoader color={"white"} size={14} />) : "Register"}
                  </button>

                  <p className="text-sm text-center text-gray-600">
                    By clicking on Register, you agree to our{" "}
                    <Link to="/TermsAndCondition" className="underline">
                      Terms & Conditions
                    </Link>{" "}
                    and{" "}
                    <Link to="/privacy" className="underline">
                      Privacy Policy
                    </Link>
                  </p>
                  <div className="text-center mt-4">
                    <span className="text-gray-600">Already a Member?</span>{" "}
                    <button onClick={() => { SetLoginPop(!Loginpop); SetRegisterpop(!Registerpop) }} className="text-indigo-500 underline">
                      Sign In
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center my-auto w-fit mx-auto text-center">
            <h1 className="text-6xl font-bold my-4 text-gray-800">
              Thanks for Registering
            </h1>
            <h2 className="text-xl font-medium mb-2 text-gray-800">
              We have sent you a <b>Verification Link</b> on your email address
            </h2>
            <p className="text-lg font-medium mb-4 text-gray-500">
              Open that Link to activate your account
            </p>
            <p className="text-lg font-medium mb-1 text-gray-800">
              Remember, the link expires after a while, so please verify promptly.
            </p>
            <p className="text-lg font-medium mb-2 w-3/4 mx-auto text-gray-800">
              If the email isn't in your inbox, check your spam/junk folder. If it's still missing, contact our <u className=" cursor-pointer">customer service</u> for help.
            </p>
          </div>

        )}
      </div>
    </div>
  );
};

export default SignUpPopUp;
